import React from 'react';
function Archievements(){
    return <>
    <div className="Name">Archievements</div>
    </>
}
export default Archievements;